import { Flex } from '@chakra-ui/layout';
import { Text } from '@chakra-ui/react';
import React from 'react';

import { colors } from 'packages/common-frontend/colors';

export const Pill = ({
  icon,
  label,
}: {
  icon: React.ReactElement;
  label: string;
}) => {
  return (
    <Flex
      as="span"
      border="1px"
      borderColor={colors.gray[200]}
      borderRadius="32px"
      padding="8px 24px"
      alignItems="center"
    >
      {icon}
      <Text
        as="span"
        color={colors.gray[600]}
        ml="8px"
        fontWeight="500"
        whiteSpace="nowrap"
      >
        {label}
      </Text>
    </Flex>
  );
};
